import baseCreateMemoryHistory from 'history/lib/createMemoryHistory';
import createBrowserHistory from 'history/lib/createBrowserHistory';
import { useRouterHistory } from 'react-router';
import { stringToQuery, queryToString } from 'utils/url';

const canUseDOM =
    typeof window !== 'undefined' &&
    typeof window.document !== 'undefined' &&
    typeof window.document.createElement !== 'undefined'; // as in react-router

// Quoting react-router/modules/createMemoryHistory.js: (useQueries is hidden in useRouterHistory)
// signatures and type checking differ between `useQueries` and
// `createMemoryHistory`, have to create `memoryHistory` first because
// `useQueries` doesn't understand the signature
const createMemoryHistory = () => baseCreateMemoryHistory();

const createRouterHistory = () => useRouterHistory(canUseDOM ? createBrowserHistory : createMemoryHistory)({ // eslint-disable-line react-hooks/rules-of-hooks
  parseQueryString: stringToQuery,
  stringifyQuery: queryToString,
});

export default createRouterHistory;
